
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("32CBT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc08d04e21e26787$export$947d923eb7e59d5c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "3GQfQ",
    name: "PublishModal",
    loader: async ()=>{
        return (await (parcelRequire("26A6c"))).PublishModal;
    }
});

const $fc08d04e21e26787$export$5a1c1fd1fd0d9704 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5nfIQ",
    name: "DiscardModal",
    loader: async ()=>{
        return (await (parcelRequire("iIOds"))).DiscardModal;
    }
});

const $fc08d04e21e26787$export$6bd5113474000445 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Xm8EX",
    name: "CancelSchedulePublishModal",
    loader: async ()=>{
        return (await (parcelRequire("kdfTS"))).CancelSchedulePublishModal;
    }
});
module.exports["PublishModal"] = $fc08d04e21e26787$export$947d923eb7e59d5c;
module.exports["DiscardModal"] = $fc08d04e21e26787$export$5a1c1fd1fd0d9704;
module.exports["CancelSchedulePublishModal"] = $fc08d04e21e26787$export$6bd5113474000445;

});

parcelRegister("26A6c", function(module, exports) {

let $188824cacb2ac1d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $188824cacb2ac1d9$var$load("hwZxn"),
    $188824cacb2ac1d9$var$load("4C4vr"),
    $188824cacb2ac1d9$var$load("05hOp"),
    $188824cacb2ac1d9$var$load("h1KXn"),
    $188824cacb2ac1d9$var$load("6wr18"),
    $188824cacb2ac1d9$var$load("6HLQW"),
    $188824cacb2ac1d9$var$load("6ufIQ"),
    $188824cacb2ac1d9$var$load("geRNh"),
    $188824cacb2ac1d9$var$load("eYxdW"),
    $188824cacb2ac1d9$var$load("aKpCc"),
    $188824cacb2ac1d9$var$load("fRhcd"),
    $188824cacb2ac1d9$var$load("kHXvF"),
    $188824cacb2ac1d9$var$load("iWnyc"),
    $188824cacb2ac1d9$var$load("ffEVr"),
    $188824cacb2ac1d9$var$load("ea3NB"),
    $188824cacb2ac1d9$var$load("hhss7"),
    $188824cacb2ac1d9$var$load("koqDJ"),
    $188824cacb2ac1d9$var$load("9TOep"),
    $188824cacb2ac1d9$var$load("4g6rd"),
    $188824cacb2ac1d9$var$load("7EorR"),
    $188824cacb2ac1d9$var$load("anQQJ")
]).then(()=>parcelRequire('9V1Xo'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("iIOds", function(module, exports) {

let $da1349e79cecd9c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $da1349e79cecd9c2$var$load("hhss7"),
    $da1349e79cecd9c2$var$load("fCqMy")
]).then(()=>parcelRequire('hpcRG'));

});

parcelRegister("kdfTS", function(module, exports) {

let $eb715aff03d16fbe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eb715aff03d16fbe$var$load("hhss7"),
    $eb715aff03d16fbe$var$load("a6uKK")
]).then(()=>parcelRequire('ic1wA'));

});

parcelRegister("ibgjl", function(module, exports) {
/**
 * @generated SignedSource<<70e47d6d0528e4546beeef67ebece23c>>
 * @relayHash c1da554fa525643c31de943858cfa545
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 448a5607a2cc42de6e2004dbb22c04163afbd333c7ca697b8f20e472973dd3ee
const $6a744162bf317657$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "alias": "user",
            "concreteType": "ConfluencePersonConnection",
            "kind": "LinkedField",
            "name": "personConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePersonEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ConfluencePerson",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "permissionType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "publicName"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "profilePicture",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "PaginatedGroupList",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Group",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "SchedulePublishInfo",
                    "kind": "LinkedField",
                    "name": "schedulePublishInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "date"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "versionComment"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "minorEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        },
                        {
                            "concreteType": "TargetLocation",
                            "kind": "LinkedField",
                            "name": "targetLocation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "parentId"
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "destinationSpace",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ScheduledRestrictions",
                            "kind": "LinkedField",
                            "name": "restrictions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScheduledRestriction",
                                    "kind": "LinkedField",
                                    "name": "update",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                },
                                {
                                    "concreteType": "ScheduledRestriction",
                                    "kind": "LinkedField",
                                    "name": "read",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PublishModalContextPublishModalWithMoreOptionsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PublishModalContextPublishModalWithMoreOptionsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "c1da554fa525643c31de943858cfa545",
            "id": "448a5607a2cc42de6e2004dbb22c04163afbd333c7ca697b8f20e472973dd3ee",
            "metadata": {},
            "name": "PublishModalContextPublishModalWithMoreOptionsQuery",
            "operationKind": "query",
            "text": "query PublishModalContextPublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id,type,space{id},schedulePublishInfo{date,versionComment,minorEdit,targetType,targetLocation{parentId,destinationSpace{id,key,alias}},restrictions{update{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}},read{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}}}}}}"
        }
    };
}();
$6a744162bf317657$var$node.hash = "b6a8ac472557078317109dfe61be9f46";
var $6a744162bf317657$export$2e2bcd8739ae039 = $6a744162bf317657$var$node;



var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $7aRa9 = parcelRequire("7aRa9");


var $gqqjz = parcelRequire("gqqjz");


var $ep3mz = parcelRequire("ep3mz");


var $bT0se = parcelRequire("bT0se");

/**
 * @generated SignedSource<<99b65033a751b10d30f933194cfec6ac>>
 * @relayHash 91cc0384b762404606db949056d3a3c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92e211e48c2af32d59acf53fdae8ddcf8b0883b0883487b88121f7eb9704874d
const $db5dcea11b9b3346$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "operation"
        },
        {
            "concreteType": "SubjectsByType",
            "kind": "LinkedField",
            "name": "restrictions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PaginatedGroupWithRestrictions",
                    "kind": "LinkedField",
                    "name": "groupWithRestrictions",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GroupWithRestrictions",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "usageType"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PaginatedUserWithRestrictions",
                    "kind": "LinkedField",
                    "name": "userWithRestrictions",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "UserWithRestrictions",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasSpaceEditPermission"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasSpaceViewPermission"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "permissionType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "publicName"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "profilePicture",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "ContentRestrictions",
                            "kind": "LinkedField",
                            "name": "restrictions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentRestriction",
                                    "kind": "LinkedField",
                                    "name": "read",
                                    "plural": false,
                                    "selections": v3 /*: any*/ 
                                },
                                {
                                    "concreteType": "ContentRestriction",
                                    "kind": "LinkedField",
                                    "name": "update",
                                    "plural": false,
                                    "selections": v3 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchRestrictionsRESTObjRestrictionsRESTQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchRestrictionsRESTObjRestrictionsRESTQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "91cc0384b762404606db949056d3a3c6",
            "id": "92e211e48c2af32d59acf53fdae8ddcf8b0883b0883487b88121f7eb9704874d",
            "metadata": {},
            "name": "useFetchRestrictionsRESTObjRestrictionsRESTQuery",
            "operationKind": "query",
            "text": "query useFetchRestrictionsRESTObjRestrictionsRESTQuery($contentId:ID!,$draftShareId:String){content(id:$contentId,status:[\"current\",\"draft\"],draftShareId:$draftShareId){nodes{id,type,restrictions{read{operation,restrictions{groupWithRestrictions{nodes{id,name,usageType}},userWithRestrictions{nodes{accountId,displayName,email,hasSpaceEditPermission,hasSpaceViewPermission,permissionType,publicName,profilePicture{path},type}}}},update{operation,restrictions{groupWithRestrictions{nodes{id,name,usageType}},userWithRestrictions{nodes{accountId,displayName,email,hasSpaceEditPermission,hasSpaceViewPermission,permissionType,publicName,profilePicture{path},type}}}}}}}}"
        }
    };
}();
$db5dcea11b9b3346$var$node.hash = "1686b4bcd3c285ffedbae0d2babd7b98";
var $db5dcea11b9b3346$export$2e2bcd8739ae039 = $db5dcea11b9b3346$var$node;






var $9DHhW = parcelRequire("9DHhW");


var $7PLO8 = parcelRequire("7PLO8");


var $jMyy4 = parcelRequire("jMyy4");

class $24eae271dbb88393$var$InvalidGraphQLRestrictionsError extends Error {
    constructor(){
        super('Invalid restrictions were fetched from GraphQL.');
    }
}
function $24eae271dbb88393$export$2a5386d9fceaced3(queryData) {
    if (!queryData) return {};
    const readRestriction = queryData?.content?.nodes?.[0]?.restrictions?.read?.restrictions;
    const updateRestriction = queryData?.content?.nodes?.[0]?.restrictions?.update?.restrictions;
    if (readRestriction === undefined || updateRestriction === undefined) throw new $24eae271dbb88393$var$InvalidGraphQLRestrictionsError();
    const result = {};
    const readUserNodes = readRestriction?.userWithRestrictions?.nodes ?? [];
    const readGroupNodes = readRestriction?.groupWithRestrictions?.nodes ?? [];
    result.read = {
        user: readUserNodes.filter((user)=>user !== null).map((user)=>({
                id: user.accountId ?? ''
            })),
        group: readGroupNodes.filter((group)=>group !== null).map((group)=>({
                name: group.name ?? '',
                id: group.id || undefined
            }))
    };
    const updateUserNodes = updateRestriction?.userWithRestrictions?.nodes ?? [];
    const updateGroupNodes = updateRestriction?.groupWithRestrictions?.nodes ?? [];
    result.update = {
        user: updateUserNodes.filter((user)=>user !== null).map((user)=>({
                id: user.accountId ?? ''
            })),
        group: updateGroupNodes.filter((group)=>group !== null).map((group)=>({
                name: group.name ?? '',
                id: group.id || undefined
            }))
    };
    return result;
}
const $24eae271dbb88393$export$27a823eb223c1015 = (restrictions)=>{
    if (!restrictions) return false;
    const onlyOneUserCanRead = (restrictions.read?.user?.length ?? 0) === 1;
    const noGroupsCanRead = (restrictions.read?.group?.length ?? 0) === 0;
    const onlyOneUserCanUpdate = (restrictions.update?.user?.length ?? 0) === 1;
    const noGroupsCanUpdate = (restrictions.update?.group?.length ?? 0) === 0;
    return onlyOneUserCanRead && noGroupsCanRead && onlyOneUserCanUpdate && noGroupsCanUpdate;
};



var $8mrqR = parcelRequire("8mrqR");

const $0881c56c6dd240f3$var$useFetchRestrictionsRESTObjRestrictionsRESTQuery = (0, $db5dcea11b9b3346$export$2e2bcd8739ae039);
const $0881c56c6dd240f3$export$8596aed048cdf431 = ({ contentId: contentId, onSuccess: onSuccess, onSuccessGql: onSuccessGql })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [transformationError, setTransformationError] = (0, $cozmU.useState)(undefined);
    const applyRestrictions = (0, $cozmU.useCallback)((completedData)=>{
        try {
            onSuccessGql?.((0, $24eae271dbb88393$export$2a5386d9fceaced3)(completedData));
            onSuccess?.((0, $8mrqR.transformGraphQLQueryToRESTObj)(completedData));
            setTransformationError(undefined);
        } catch (restrictionsError) {
            setTransformationError(restrictionsError);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'error',
                    actionSubject: 'fetchRestrictions',
                    actionSubjectId: 'fetchRestrictionsError',
                    source: 'useFetchRestrictionsRESTObj',
                    attributes: {
                        message: restrictionsError.message
                    }
                }
            }).fire();
        }
    }, [
        onSuccess,
        onSuccessGql,
        createAnalyticsEvent
    ]);
    const { error: error, refetch: refetch, loading: loading } = (0, $jMyy4.useQueryInterop)($0881c56c6dd240f3$var$useFetchRestrictionsRESTObjRestrictionsRESTQuery, {
        variables: {
            contentId: contentId,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        onCompleted: applyRestrictions,
        __callerPackage__: "restrictions"
    });
    /** Applies the refetch result directly, since `onCompleted` does not fire for refetches. */ const refetchAndApply = (0, $cozmU.useCallback)(async ()=>{
        const result = await refetch().catch(()=>undefined);
        if (result?.data) applyRestrictions(result.data);
    }, [
        refetch,
        applyRestrictions
    ]);
    return {
        error: error || transformationError,
        refetch: refetchAndApply,
        loading: loading
    };
};




var $laFNM = parcelRequire("laFNM");


var $i9VoI = parcelRequire("i9VoI");


var $1xpoY = parcelRequire("1xpoY");


var $6mKj3 = parcelRequire("6mKj3");





var $6vt06 = parcelRequire("6vt06");


var $6pob4 = parcelRequire("6pob4");


var $jVFPV = parcelRequire("jVFPV");

const $8e5ec683a0a81bad$var$DEFAULT_SETTINGS = {
    pendingScheduledPublishDate: undefined,
    versionComments: '',
    publishAsBlog: false,
    shouldNotify: true,
    moveParams: undefined,
    restrictionsObj: undefined,
    gqlRestrictionsInput: undefined,
    publishModalPrincipals: undefined,
    publishModalGeneralAccess: undefined
};
const $8e5ec683a0a81bad$export$df066e33be73e48e = ()=>Promise.resolve({
        title: '',
        adf: {
            type: ''
        }
    });
const $8e5ec683a0a81bad$export$5bbc09a836707eff = /*#__PURE__*/ (0, $cozmU.createContext)({
    ...$8e5ec683a0a81bad$var$DEFAULT_SETTINGS,
    currentlyScheduledPublishDate: undefined,
    setCurrentlyScheduledPublishDate: ()=>{},
    setPendingScheduledPublishDate: ()=>{},
    scheduledPublishDate: undefined,
    setVersionComments: ()=>{},
    setPublishAsBlog: ()=>{},
    expanded: false,
    setExpanded: ()=>{},
    setShouldNotify: ()=>{},
    setRestrictionsObj: ()=>{},
    setGqlRestrictionsInput: ()=>{},
    setPublishModalPrincipals: ()=>{},
    setPublishModalGeneralAccess: ()=>{},
    hasModifiedRestrictions: false,
    refetchAll: ()=>{},
    shouldNotifyComputedValue: true,
    discardCurrentState: ()=>{},
    graphqlError: undefined,
    restrictionsGraphQLError: undefined,
    isRestrictionsLoading: false,
    onClickPublish: ()=>{},
    onClickPreview: ()=>{},
    retrieveEditorTitleAndContent: $8e5ec683a0a81bad$export$df066e33be73e48e,
    flags: new (0, $gqqjz.FlagsStateContainer)([]),
    hasModifiedSettings: true,
    isBlog: false,
    setIsBlog: ()=>{},
    setMoveParams: ()=>{},
    hasModifiedLocation: false,
    hasScheduledRestrictions: false,
    setHasScheduledRestrictions: ()=>{},
    isConvertToPageDialog: false,
    modalSource: undefined,
    targetSpaceHasBlogsDisabled: false,
    isUserSpaceAdminOfTargetSpace: false,
    blogTargetSpaceKey: undefined,
    isTargetSpaceBlogCheckLoading: false
});
const $8e5ec683a0a81bad$export$d831d07c578114dd = ()=>{
    const [currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate] = (0, $cozmU.useState)(undefined);
    const [pendingScheduledPublishDate, setPendingScheduledPublishDate] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.pendingScheduledPublishDate);
    const [versionComments, setVersionComments] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.versionComments);
    const [publishAsBlog, setPublishAsBlog] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishAsBlog);
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    const [shouldNotify, setShouldNotify] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.shouldNotify);
    // undefined indicates that no user-initiated changes have been mode to restrictions
    const [restrictionsObj, setRestrictionsObj] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.restrictionsObj);
    const [gqlRestrictionsInput, setGqlRestrictionsInput] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.gqlRestrictionsInput);
    const [publishModalPrincipals, setPublishModalPrincipals] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishModalPrincipals);
    const [publishModalGeneralAccess, setPublishModalGeneralAccess] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishModalGeneralAccess);
    const [savedSnapshot, setSavedSnapshot] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS);
    const [hasScheduledRestrictions, setHasScheduledRestrictions] = (0, $cozmU.useState)(false);
    const [isBlog, setIsBlog] = (0, $cozmU.useState)(false);
    const [moveParams, setMoveParams] = (0, $cozmU.useState)($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.moveParams);
    // When the publish modal opens and a date is already scheduled on the backend,
    // the pendingScheduledPublishDate is set to undefined to indicate there is
    // no date picked by the user, while the currentlyScheduledPublishDate will
    // have the actualy scheduled date value.
    // This check prevents that situation from triggering the discard dialog.
    const hasModifiedDate = currentlyScheduledPublishDate?.getTime() !== pendingScheduledPublishDate?.getTime() && pendingScheduledPublishDate !== undefined;
    const hasModifiedRestrictions = gqlRestrictionsInput !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(savedSnapshot.gqlRestrictionsInput, gqlRestrictionsInput);
    const hasModifiedLocation = savedSnapshot.publishAsBlog !== publishAsBlog || savedSnapshot.moveParams !== moveParams;
    const hasModifiedSettings = hasModifiedDate || savedSnapshot.versionComments !== versionComments || savedSnapshot.shouldNotify !== shouldNotify || hasModifiedLocation || hasModifiedRestrictions;
    /* Function to discard current state on modal close */ const discardCurrentState = ()=>{
        setPendingScheduledPublishDate($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.pendingScheduledPublishDate);
        setVersionComments($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.versionComments);
        setPublishAsBlog($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishAsBlog);
        setShouldNotify($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.shouldNotify);
        setMoveParams($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.moveParams);
        setRestrictionsObj($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.restrictionsObj);
        setGqlRestrictionsInput($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.gqlRestrictionsInput);
        setPublishModalPrincipals($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishModalPrincipals);
        setPublishModalGeneralAccess($8e5ec683a0a81bad$var$DEFAULT_SETTINGS.publishModalGeneralAccess);
        setSavedSnapshot((prev)=>({
                ...$8e5ec683a0a81bad$var$DEFAULT_SETTINGS,
                restrictionsObj: prev.restrictionsObj,
                gqlRestrictionsInput: prev.gqlRestrictionsInput
            }));
    };
    const scheduledPublishDate = pendingScheduledPublishDate ?? currentlyScheduledPublishDate;
    return {
        currentlyScheduledPublishDate: currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate,
        pendingScheduledPublishDate: pendingScheduledPublishDate,
        setPendingScheduledPublishDate: setPendingScheduledPublishDate,
        versionComments: versionComments,
        setVersionComments: setVersionComments,
        publishAsBlog: publishAsBlog,
        setPublishAsBlog: setPublishAsBlog,
        expanded: expanded,
        setExpanded: setExpanded,
        shouldNotify: shouldNotify,
        setShouldNotify: setShouldNotify,
        restrictionsObj: restrictionsObj,
        setRestrictionsObj: setRestrictionsObj,
        gqlRestrictionsInput: gqlRestrictionsInput,
        setGqlRestrictionsInput: setGqlRestrictionsInput,
        publishModalPrincipals: publishModalPrincipals,
        setPublishModalPrincipals: setPublishModalPrincipals,
        publishModalGeneralAccess: publishModalGeneralAccess,
        setPublishModalGeneralAccess: setPublishModalGeneralAccess,
        hasModifiedRestrictions: hasModifiedRestrictions,
        scheduledPublishDate: scheduledPublishDate,
        discardCurrentState: discardCurrentState,
        savedSnapshot: savedSnapshot,
        setSavedSnapshot: setSavedSnapshot,
        hasModifiedSettings: hasModifiedSettings,
        isBlog: isBlog,
        setIsBlog: setIsBlog,
        setMoveParams: setMoveParams,
        moveParams: moveParams,
        hasModifiedLocation: hasModifiedLocation,
        hasScheduledRestrictions: hasScheduledRestrictions,
        setHasScheduledRestrictions: setHasScheduledRestrictions
    };
};
const $8e5ec683a0a81bad$export$d24968a4528c903e = (0, $7aRa9.withFlags)(({ children: children, onClickPublish: onClickPublish, onClickPreview: onClickPreview, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, isConvertToPageDialog: isConvertToPageDialog = false })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { modalSource: modalSource } = (0, $6pob4.usePublishModalMountStore)();
    /**
   * Live-doc → page approval flow: when the user initiated this publish flow from the
   * live-doc Start Approval popup, force convert-to-page mode for the dialog regardless
   * of what the caller passed. The intent lives on ApprovalsContext (the only place all
   * three of approvals/publish-modal/content-state already share without creating a
   * cycle).
   *
   */ const { pendingLiveDocApprovalContentId: pendingLiveDocApprovalContentId } = (0, $laFNM.useApprovals)();
    const effectiveIsConvertToPageDialog = isConvertToPageDialog || Boolean(pendingLiveDocApprovalContentId) && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true);
    /* State declarations */ const { currentlyScheduledPublishDate: currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate, pendingScheduledPublishDate: pendingScheduledPublishDate, setPendingScheduledPublishDate: setPendingScheduledPublishDate, versionComments: versionComments, setVersionComments: setVersionComments, publishAsBlog: publishAsBlog, setPublishAsBlog: setPublishAsBlog, expanded: expanded, setExpanded: setExpanded, shouldNotify: shouldNotify, setShouldNotify: setShouldNotify, restrictionsObj: restrictionsObj, setRestrictionsObj: setRestrictionsObj, gqlRestrictionsInput: gqlRestrictionsInput, setGqlRestrictionsInput: setGqlRestrictionsInput, publishModalPrincipals: publishModalPrincipals, setPublishModalPrincipals: setPublishModalPrincipals, publishModalGeneralAccess: publishModalGeneralAccess, setPublishModalGeneralAccess: setPublishModalGeneralAccess, hasModifiedRestrictions: hasModifiedRestrictions, scheduledPublishDate: scheduledPublishDate, discardCurrentState: discardCurrentState, savedSnapshot: savedSnapshot, setSavedSnapshot: setSavedSnapshot, hasModifiedSettings: hasModifiedSettings, isBlog: isBlog, setIsBlog: setIsBlog, setMoveParams: setMoveParams, moveParams: moveParams, hasModifiedLocation: hasModifiedLocation, hasScheduledRestrictions: hasScheduledRestrictions, setHasScheduledRestrictions: setHasScheduledRestrictions } = $8e5ec683a0a81bad$export$d831d07c578114dd();
    const { getSpaceSidebarWebItems: getSpaceSidebarWebItems, spaceSidebarWebItemsLoading: spaceSidebarWebItemsLoading, spaceSidebarWebItemsError: spaceSidebarWebItemsError, selectedSpaceHasBlogsToggledOff: selectedSpaceHasBlogsToggledOff, isUserSpaceAdminOfTargetSpace: isUserSpaceAdminOfTargetSpace } = (0, $6vt06.useDoesTargetSpaceHaveDisabledBlogs)();
    const blogTargetSpaceKey = publishAsBlog ? moveParams?.newSpaceKey ?? (!isBlog ? currentSpaceKey : undefined) : undefined;
    (0, $cozmU.useEffect)(()=>{
        if (blogTargetSpaceKey) getSpaceSidebarWebItems({
            variables: {
                spaceKey: blogTargetSpaceKey
            }
        });
    // getSpaceSidebarWebItems is a stable lazy-query trigger; re-run only when the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        blogTargetSpaceKey
    ]);
    const targetSpaceHasBlogsDisabled = Boolean(blogTargetSpaceKey && // Fail closed if the blogs-enabled check errors.
    (selectedSpaceHasBlogsToggledOff || spaceSidebarWebItemsError) && (0, $6mKj3.expVal)('cc_perms_block_publish_blog_to_disabled_space', 'isEnabled', false));
    const isTargetSpaceBlogCheckLoading = Boolean(blogTargetSpaceKey && spaceSidebarWebItemsLoading);
    const onSchedulePublishPubsubEvent = (0, $cozmU.useCallback)((_, payload)=>{
        if (![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $1xpoY.default).getString('confluence-migrate-fps-to-graphql-subscription', ''))) {
            const { schedulePublishRequestBody: { publishTime: publishTime, eventType: eventType } } = payload;
            if (eventType === 'scheduled') {
                if (!currentlyScheduledPublishDate || currentlyScheduledPublishDate?.toISOString() !== publishTime) setCurrentlyScheduledPublishDate(new Date(publishTime));
            } else if (eventType === 'unscheduled') {
                if (currentlyScheduledPublishDate) setCurrentlyScheduledPublishDate(undefined);
            }
        }
    }, [
        currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate
    ]);
    const onSchedulePublishSubscriptionEvent = (0, $cozmU.useCallback)((_delta, response)=>{
        const { eventType: eventType, publishTime: publishTime } = response?.schedulePublished || {};
        if (eventType === 'SCHEDULED') {
            if (!currentlyScheduledPublishDate || currentlyScheduledPublishDate?.toISOString() !== publishTime) setCurrentlyScheduledPublishDate(new Date(publishTime));
        } else if (eventType === 'UNSCHEDULED') {
            if (currentlyScheduledPublishDate) setCurrentlyScheduledPublishDate(undefined);
        }
    }, [
        currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate
    ]);
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId ?? '',
        contentType: contentType ?? 'page',
        eventName: contentType === 'blogpost' ? 'schedulePublish:blogpost' : 'schedulePublish:page',
        onEvent: onSchedulePublishPubsubEvent,
        skip: (0, $1xpoY.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId ?? '',
        contentType: contentType ?? 'page',
        subscriberId: 'PublishModalContextSubscription',
        delta: 'schedulePublished',
        skip: ![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $1xpoY.default).getString('confluence-migrate-fps-to-graphql-subscription', '')),
        onDataReceived: onSchedulePublishSubscriptionEvent
    });
    // Memoized so the fetch hook's data-effect keeps a stable identity behind the gate; an
    // unstable callback would re-run that effect every render and loop on setSavedSnapshot.
    const onFetchRestrictionsSuccess = (0, $cozmU.useCallback)((newRestrictions)=>{
        // Snapshot should match scheduled restrictions instead of true restrictions
        if (hasScheduledRestrictions) return;
        setSavedSnapshot((prev)=>({
                ...prev,
                restrictionsObj: newRestrictions
            }));
    }, [
        hasScheduledRestrictions,
        setSavedSnapshot
    ]);
    const onFetchRestrictionsSuccessGql = (0, $cozmU.useCallback)((newGqlRestrictions)=>{
        if (hasScheduledRestrictions) return;
        setSavedSnapshot((prev)=>({
                ...prev,
                gqlRestrictionsInput: newGqlRestrictions
            }));
    }, [
        hasScheduledRestrictions,
        setSavedSnapshot
    ]);
    const { error: restrictionsGraphQLError, refetch: refetchRestrictions, loading: isRestrictionsLoading } = (0, $0881c56c6dd240f3$export$8596aed048cdf431)({
        contentId: contentId ?? '',
        onSuccess: onFetchRestrictionsSuccess,
        onSuccessGql: onFetchRestrictionsSuccessGql
    });
    const isFirstTimeBlogPost = isUnpublishedDraft && isBlog;
    let shouldNotifyComputedValue = shouldNotify;
    const computedRestrictions = hasModifiedRestrictions ? restrictionsObj : savedSnapshot.restrictionsObj;
    const computedGqlRestrictionsInput = hasModifiedRestrictions ? gqlRestrictionsInput : savedSnapshot.gqlRestrictionsInput;
    const isPrivateToYouOnly = computedGqlRestrictionsInput && (0, $24eae271dbb88393$export$27a823eb223c1015)(computedGqlRestrictionsInput);
    if (isPrivateToYouOnly) shouldNotifyComputedValue = false;
    else if (publishAsBlog || isFirstTimeBlogPost) shouldNotifyComputedValue = true;
    const loadQueryDataIntoPublishModalState = (newQueryData)=>{
        let nextCurrentlyScheduledPublishDate;
        let nextPendingScheduledPublishDate;
        let nextExpanded = expanded;
        let nextShouldNotify;
        let nextPublishAsBlog = publishAsBlog;
        let nextRestrictionsRestObj = restrictionsObj;
        let nextGqlRestrictionsInput = gqlRestrictionsInput;
        let nextmoveParams = moveParams;
        const schedulePublishInfo = newQueryData?.singleContent?.schedulePublishInfo;
        if (schedulePublishInfo?.date) {
            nextCurrentlyScheduledPublishDate = new Date(Date.parse(schedulePublishInfo?.date));
            nextPendingScheduledPublishDate = undefined;
            nextExpanded = true;
        } else {
            nextCurrentlyScheduledPublishDate = undefined;
            nextPendingScheduledPublishDate = undefined;
        }
        const nextVersionComments = schedulePublishInfo?.versionComment ?? '';
        if (typeof schedulePublishInfo?.minorEdit === 'boolean') // if minorEdit==false then we should notify
        nextShouldNotify = !schedulePublishInfo?.minorEdit;
        else // if we don't have a value for this, set to true which is the default
        nextShouldNotify = true;
        nextPublishAsBlog = schedulePublishInfo?.targetType === 'blogpost' && newQueryData?.singleContent?.type !== 'blogpost';
        const targetLocation = schedulePublishInfo?.targetLocation;
        if (targetLocation?.destinationSpace?.key) {
            nextmoveParams = {
                newSpaceKey: targetLocation?.destinationSpace?.alias || targetLocation?.destinationSpace?.key
            };
            if (targetLocation?.parentId) nextmoveParams = {
                ...nextmoveParams,
                newParentPageId: targetLocation?.parentId
            };
        }
        if (schedulePublishInfo?.restrictions) {
            setHasScheduledRestrictions(true);
            nextRestrictionsRestObj = (0, $jVFPV.convertRestrictionsObjFromSchedulePublishInfo)(schedulePublishInfo?.restrictions);
            nextGqlRestrictionsInput = (0, $jVFPV.convertGqlRestrictionsInputFromSchedulePublishInfo)(schedulePublishInfo?.restrictions);
        }
        setCurrentlyScheduledPublishDate(nextCurrentlyScheduledPublishDate);
        setPendingScheduledPublishDate(nextPendingScheduledPublishDate);
        setExpanded(nextExpanded);
        setVersionComments(nextVersionComments);
        setShouldNotify(nextShouldNotify);
        setPublishAsBlog(nextPublishAsBlog);
        setRestrictionsObj(nextRestrictionsRestObj);
        setGqlRestrictionsInput(nextGqlRestrictionsInput);
        setMoveParams(nextmoveParams);
        // TODO: GENI-2751 - Read staged locations from schedule publish info
        // and stage to snapshot with moveParams
        setSavedSnapshot((oldSavedSnapshot)=>({
                pendingScheduledPublishDate: nextPendingScheduledPublishDate,
                versionComments: nextVersionComments,
                publishAsBlog: nextPublishAsBlog,
                shouldNotify: nextShouldNotify,
                moveParams: nextmoveParams,
                // If savedSnapshot.restrictionsObj has just been set by useFetchRestrictionsRESTObj, we need to not override what it just set.
                restrictionsObj: nextRestrictionsRestObj ?? oldSavedSnapshot.restrictionsObj,
                // If savedSnapshot.gqlRestrictionsInput has just been set by useFetchRestrictionsRESTObj, we need to not override what it just set.
                gqlRestrictionsInput: nextGqlRestrictionsInput ?? oldSavedSnapshot.gqlRestrictionsInput,
                // Preserve staged principals and general access
                publishModalPrincipals: oldSavedSnapshot.publishModalPrincipals,
                publishModalGeneralAccess: oldSavedSnapshot.publishModalGeneralAccess
            }));
    };
    /* Fetching already scheduled publish data */ const { data: queryData, error: graphqlError, refetch: refetchPublishModalQuery } = (0, $jMyy4.useQueryInterop)((0, $6a744162bf317657$export$2e2bcd8739ae039), {
        errorPolicy: 'all',
        fetchPolicy: 'cache-and-network',
        variables: {
            contentId: contentId
        },
        onCompleted: loadQueryDataIntoPublishModalState,
        __callerPackage__: "publish-modal"
    });
    (0, $cozmU.useEffect)(()=>{
        const schedulePublishDateFromQuery = queryData?.singleContent?.schedulePublishInfo?.date;
        if (schedulePublishDateFromQuery) {
            const newSchedulePublishDateFromQuery = new Date(Date.parse(schedulePublishDateFromQuery));
            setCurrentlyScheduledPublishDate(newSchedulePublishDateFromQuery);
        }
    }, [
        queryData?.singleContent?.schedulePublishInfo?.date,
        setCurrentlyScheduledPublishDate
    ]);
    const resetToInitialState = ()=>{
        if (queryData?.singleContent?.schedulePublishInfo?.date) // If this page is currently scheduled to be published,
        // then load the settings of the current scheduled publish from the backend.
        loadQueryDataIntoPublishModalState(queryData);
        else discardCurrentState();
    };
    const refetchAll = (0, $cozmU.useCallback)(()=>{
        refetchPublishModalQuery();
        refetchRestrictions();
    }, [
        refetchPublishModalQuery,
        refetchRestrictions
    ]);
    /* Objects that are provided via the context */ const contextProvidedData = {
        currentlyScheduledPublishDate: currentlyScheduledPublishDate,
        setCurrentlyScheduledPublishDate: setCurrentlyScheduledPublishDate,
        pendingScheduledPublishDate: pendingScheduledPublishDate,
        setPendingScheduledPublishDate: setPendingScheduledPublishDate,
        scheduledPublishDate: scheduledPublishDate,
        versionComments: versionComments,
        setVersionComments: setVersionComments,
        publishAsBlog: publishAsBlog,
        setPublishAsBlog: setPublishAsBlog,
        expanded: expanded,
        setExpanded: setExpanded,
        shouldNotify: shouldNotify,
        setShouldNotify: setShouldNotify,
        restrictionsObj: computedRestrictions,
        setRestrictionsObj: setRestrictionsObj,
        gqlRestrictionsInput: computedGqlRestrictionsInput,
        setGqlRestrictionsInput: setGqlRestrictionsInput,
        publishModalPrincipals: publishModalPrincipals,
        setPublishModalPrincipals: setPublishModalPrincipals,
        publishModalGeneralAccess: publishModalGeneralAccess,
        setPublishModalGeneralAccess: setPublishModalGeneralAccess,
        hasModifiedRestrictions: hasModifiedRestrictions,
        refetchAll: refetchAll,
        shouldNotifyComputedValue: shouldNotifyComputedValue,
        graphqlError: graphqlError,
        restrictionsGraphQLError: restrictionsGraphQLError,
        isRestrictionsLoading: isRestrictionsLoading,
        discardCurrentState: resetToInitialState,
        onClickPublish: onClickPublish,
        onClickPreview: onClickPreview,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        flags: flags,
        hasModifiedSettings: hasModifiedSettings,
        isBlog: isBlog,
        setIsBlog: setIsBlog,
        setMoveParams: setMoveParams,
        moveParams: moveParams,
        hasModifiedLocation: hasModifiedLocation,
        hasScheduledRestrictions: hasScheduledRestrictions,
        setHasScheduledRestrictions: setHasScheduledRestrictions,
        isConvertToPageDialog: effectiveIsConvertToPageDialog,
        modalSource: effectiveIsConvertToPageDialog ? modalSource : undefined,
        targetSpaceHasBlogsDisabled: targetSpaceHasBlogsDisabled,
        isUserSpaceAdminOfTargetSpace: isUserSpaceAdminOfTargetSpace,
        blogTargetSpaceKey: blogTargetSpaceKey,
        isTargetSpaceBlogCheckLoading: isTargetSpaceBlogCheckLoading
    };
    return(// oxlint-disable-next-line react/jsx-no-constructed-context-values
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e5ec683a0a81bad$export$5bbc09a836707eff.Provider, {
        value: contextProvidedData
    }, children));
});
const $8e5ec683a0a81bad$export$c88291018b2907cc = (WrappedComponent)=>({ onClickPublish: onClickPublish, onClickPreview: onClickPreview, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, isConvertToPageDialog: isConvertToPageDialog, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e5ec683a0a81bad$export$d24968a4528c903e, {
            onClickPublish: onClickPublish,
            onClickPreview: onClickPreview,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            isUnpublishedDraft: isUnpublishedDraft,
            contentType: contentType,
            isConvertToPageDialog: isConvertToPageDialog
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            isUnpublishedDraft: isUnpublishedDraft,
            contentType: contentType,
            ...props
        }));
    };
module.exports["PublishModalContext"] = $8e5ec683a0a81bad$export$5bbc09a836707eff;
module.exports["withPublishModalContextProvider"] = $8e5ec683a0a81bad$export$c88291018b2907cc;

});

parcelRegister("4f2ij", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aRGok = parcelRequire("aRGok");


var $ep3mz = parcelRequire("ep3mz");


var $32CBT = parcelRequire("32CBT");


var $ibgjl = parcelRequire("ibgjl");





var $f8dGE = parcelRequire("f8dGE");


var $ePExc = parcelRequire("ePExc");




const $ebcc7d0d34ae1e7f$export$13cacc04cd9a5e8b = ({ onClose: onClose, contentId: contentId, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft })=>{
    const { restrictionsObj: restrictionsObj, setRestrictionsObj: setRestrictionsObj, setGqlRestrictionsInput: setGqlRestrictionsInput, setPublishModalPrincipals: setPublishModalPrincipals, setPublishModalGeneralAccess: setPublishModalGeneralAccess, publishModalPrincipals: publishModalPrincipals, publishModalGeneralAccess: publishModalGeneralAccess, hasModifiedRestrictions: hasModifiedRestrictions, hasScheduledRestrictions: hasScheduledRestrictions } = (0, $cozmU.useContext)((0, $ibgjl.PublishModalContext));
    // Clean up setRestrictionsDeepCopy when use_graphql_to_publish_pages_and_blogs is cleaned up
    const setRestrictionsDeepCopy = (0, $cozmU.useCallback)((newVal)=>{
        const clone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(newVal);
        setRestrictionsObj(clone);
    }, [
        setRestrictionsObj
    ]);
    const setGqlRestrictionsInputCallback = (0, $cozmU.useCallback)((newVal)=>{
        const clone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(newVal);
        setGqlRestrictionsInput(clone);
    }, [
        setGqlRestrictionsInput
    ]);
    const preloadRestrictions = hasModifiedRestrictions || hasScheduledRestrictions ? restrictionsObj : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ePExc.ShareAndRestrictDialogController), {
        contentId: contentId,
        contentType: contentType,
        allowRestrictions: true,
        pageModes: "view",
        refetchButtonData: ()=>{},
        onClose: onClose,
        publishModalRestrictions: preloadRestrictions,
        publishModalPrincipals: publishModalPrincipals,
        publishModalGeneralAccess: publishModalGeneralAccess,
        pushPublishModalRestrictions: setRestrictionsDeepCopy,
        pushPublishModalGqlRestrictionsInput: setGqlRestrictionsInputCallback,
        pushPublishModalPrincipals: setPublishModalPrincipals,
        pushPublishModalGeneralAccess: setPublishModalGeneralAccess,
        isUnpublishedDraft: isUnpublishedDraft
    });
};


const $5ded9942f908b7ae$export$2ade9573a6e2bedc = ({ isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, title: title, publishButtonDisabled: publishButtonDisabled, userViewingPreview: userViewingPreview, initialFocusTarget: initialFocusTarget, shouldShowWorldIcon: shouldShowWorldIcon, shouldShowFooterButtons: shouldShowFooterButtons = true, onPublishModalComplete: onPublishModalComplete, onHoverPublish: onHoverPublish })=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { discardCurrentState: discardCurrentState, hasModifiedSettings: hasModifiedSettings, refetchAll: refetchAll } = (0, $cozmU.useContext)((0, $ibgjl.PublishModalContext));
    const [publishModalIsOpen, setPublishModalIsOpen] = (0, $cozmU.useState)(true);
    const [discardModalIsOpen, setDiscardModalIsOpen] = (0, $cozmU.useState)(false);
    // A ref is needed here so queuedFinalClose can have its value update right away.
    // It is not used in any render functions, so it's OK to use a ref here.
    const queuedFinalCloseRef = (0, $cozmU.useRef)(false);
    const [focusField, setFocusField] = (0, $cozmU.useState)(initialFocusTarget);
    const [permissionsDialogIsOpen, setPermissionsDialogIsOpen] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        // We need to refetch the PublishModal state immediately before opening the modal so we can be sure we have the latest settings.
        refetchAll();
    }, [
        refetchAll
    ]);
    const openPermissionsDialog = ()=>{
        setPermissionsDialogIsOpen(true);
    };
    const closePermissionsDialog = ()=>{
        setPermissionsDialogIsOpen(false);
    };
    /*
   * The openModal function below opens the publish modal.
   * It is sometimes used to return to the publish modal after its sub-dialogs (like the permissions dialog) are closed.
   */ const openModal = (focus)=>{
        setPublishModalIsOpen(true);
        setFocusField(focus);
    };
    // The boolean endPublishExperience should be true if this closes all sub-modals and ends the PublishModal experience.
    // If endPublishExperience is false, the PublishModal will be closed but the PublishModal experience will continue, so other sub-modals like the MovePageDialog can render.
    const closeModal = ({ endPublishExperience: endPublishExperience })=>{
        if (endPublishExperience) queuedFinalCloseRef.current = true;
        setPublishModalIsOpen(false);
    };
    const onCloseComplete = ()=>{
        if (queuedFinalCloseRef.current) onPublishModalComplete();
    };
    const requestCloseModal = ()=>{
        if (hasModifiedSettings) setDiscardModalIsOpen(true);
        else {
            discardCurrentState();
            closeModal({
                endPublishExperience: true
            });
        }
    };
    const closeDiscardModal = ()=>{
        setDiscardModalIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, publishModalIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32CBT.PublishModal), {
        publishButtonDisabled: publishButtonDisabled,
        closeModal: closeModal,
        openModal: openModal,
        requestCloseModal: requestCloseModal,
        onCloseComplete: onCloseComplete,
        isUnpublishedDraft: isUnpublishedDraft,
        openPermissionsDialog: ()=>{
            closeModal({
                endPublishExperience: false
            });
            openPermissionsDialog();
        },
        userViewingPreview: userViewingPreview,
        title: title,
        focusField: focusField,
        setFocusField: setFocusField,
        shouldShowWorldIcon: shouldShowWorldIcon,
        shouldShowFooterButtons: shouldShowFooterButtons,
        onHoverPublish: onHoverPublish
    })), permissionsDialogIsOpen && // ShareAndRestrictDialogController must be rendered outside of a ModalTransition, as it is not a Modal directly.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ebcc7d0d34ae1e7f$export$13cacc04cd9a5e8b), {
        contentId: contentId,
        contentType: contentType,
        onClose: ()=>{
            closePermissionsDialog();
            openModal('access');
        },
        isUnpublishedDraft: isUnpublishedDraft
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, discardModalIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32CBT.DiscardModal), {
        closeModal: closeModal,
        closeDiscardModal: closeDiscardModal,
        isUnpublishedDraft: isUnpublishedDraft
    })));
};
module.exports["PublishModalDialogs"] = $5ded9942f908b7ae$export$2ade9573a6e2bedc;

});


//# sourceMappingURL=PublishButtonWithMoreOptions.d1f21f56.js.map
